import { Container, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

interface Props {
  error?: string;
}

export const ErrorPage = ({ error }: Props) => {
    return (
        <Container className="my-5">
            <Row className="justify-content-center">
                <Col md={12} style={{ color: "darkred" }}>
                    <h4>{error ?? "An unexpected error occured. Please try again or contact App Support."}</h4>
                    <Link className="btn btn-primary mt-1" to="/">
                        Back to Home
                    </Link>
                </Col>
            </Row>
        </Container>
    );
};
